import type { TFunction } from 'i18next';
import type { SessionItem } from './use-sessions';

type LoginMethod = NonNullable<SessionItem['login_method']>;

const KEY_BY_METHOD: Record<LoginMethod['method'], string> = {
  password: 'method_password',
  mfa: 'method_mfa',
  passkey: 'method_passkey',
  passkey_mfa: 'method_passkey_mfa',
  email_otp: 'method_email_otp',
  magic_link: 'method_magic_link',
  recovery_code: 'method_recovery_code',
  // sso is handled with idp interpolation in authMethodLabel; this entry only
  // keeps the Record<> exhaustive over the method union.
  sso: 'method_sso',
  impersonation: 'method_impersonation',
  device_code: 'method_device_code',
};

/** Localized, user-facing label for a session's login method. */
export function authMethodLabel(
  lm: SessionItem['login_method'] | undefined,
  t: TFunction,
): string {
  if (!lm) return t('method_unknown');
  if (lm.method === 'sso') {
    return lm.idp_name ? t('method_sso', { idp: lm.idp_name }) : t('method_sso_generic');
  }
  return t(KEY_BY_METHOD[lm.method] ?? 'method_unknown');
}
